import React, {FC} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {Employee} from "../../../lib/src/api/dto/Employee"
import {useApi} from "../api/APIContext";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";


export const DisableLoginModal: FC<{employee: Employee}> = (props) => {
  const {updateEmployee} = useApi()
  const confirm = async () => {
    await updateEmployee({...props.employee, email: null})
  }

  return <form>
    <p className={""}>
      <strong>Let op!</strong> Je staat op het punt om de login van <strong>{props.employee.firstName} {props.employee.lastName}</strong> uit te schakelen.
    </p>
    <ModalFooter icon={fa.faTimes} text={"Login uitschakelen"} onSubmit={confirm} />
  </form>
}
